import firebase from "firebase/app";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDON1ChH7UNiznTkkRF-HwNhWvTwQ-bmC0",
  authDomain: "adenzo-pos-test.firebaseapp.com",
  projectId: "adenzo-pos-test",
  storageBucket: "adenzo-pos-test.appspot.com",
  messagingSenderId: "795584700615",
  appId: "1:795584700615:web:e6f2e91400275b37b59ee2",
  measurementId: "G-RQ6H0K9VQG",
};

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();

export { storage, firebase as default };
